/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FunnelProductOwnerDto
 */
export interface FunnelProductOwnerDto {
    /**
     * Unique identifier of the product owner
     * @type {string}
     * @memberof FunnelProductOwnerDto
     */
    id?: string;
    /**
     * Name of the product owner
     * @type {string}
     * @memberof FunnelProductOwnerDto
     */
    name?: string;
}

/**
 * Check if a given object implements the FunnelProductOwnerDto interface.
 */
export function instanceOfFunnelProductOwnerDto(value: object): value is FunnelProductOwnerDto {
    return true;
}

export function FunnelProductOwnerDtoFromJSON(json: any): FunnelProductOwnerDto {
    return FunnelProductOwnerDtoFromJSONTyped(json, false);
}

export function FunnelProductOwnerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunnelProductOwnerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function FunnelProductOwnerDtoToJSON(json: any): FunnelProductOwnerDto {
    return FunnelProductOwnerDtoToJSONTyped(json, false);
}

export function FunnelProductOwnerDtoToJSONTyped(value?: FunnelProductOwnerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

